import { Link, useParams, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Multiplayer from "./Multiplayer";
import { endPoints } from "../../../config/end-points";
import { audioList } from "../../../config/audio-config";
import { authActions } from "../../../store/auth";
import { useDispatch } from "react-redux";

const AudioList = () => {
  // const [templateId, setTemplateId] = useState(null);
  const [isValidURL, setIsValidURL] = useState(true);
  const dispatch = useDispatch();
  // const audios = [
  //   {
  //     id: 1,
  //     name: "goodbye stress calming acoustic guitar",
  //     url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/7.mp3",
  //   },
  //   {
  //     id: 2,
  //     name: "funky trap sax",
  //     url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/2.mp3",
  //   },
  //   {
  //     id: 3,
  //     name: "soft instrumental hip hop",
  //     url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/3.mp3",
  //   },
  //   {
  //     id: 4,
  //     name: "future bass beat",
  //     url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/4.mp3",
  //   },
  //   {
  //     id: 5,
  //     name: "stomp and claps",
  //     url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/6.mp3",
  //   },
  //   {
  //     id: 6,
  //     name: "epic",
  //     url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/1.mp3",
  //   },
  //   {
  //     id: 7,
  //     name: "dreamy piano soft sound ambient",
  //     url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/10.mp3",
  //   },
  //   {
  //     id: 8,
  //     name: "innovation",
  //     url: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/audios/11.mp3",
  //   },
  // ];
  // eslint-disable-next-line no-unused-vars
  const [audios, setAudios] = useState(audioList);

  const { camp_id } = useParams();

  const { sendRequest } = useHttp();
  const history = useHistory();

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: true }));

    const responseData = (response) => {
      if (!response.body) {
        setIsValidURL(false);
      } else {
        if (response.body.process_flow >= 2) {
          history.push("/render/" + camp_id);
        }
        setIsValidURL(true);

        // setTemplateId(response.template_id);
      }
      dispatch(authActions.setLoaderStatus({ status: false }));
    };
    sendRequest(
      { url: endPoints.fetchCampaign + "/" + camp_id, method: "GET" },
      responseData
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camp_id, history, sendRequest]);

  return (
    <section className="mid_wrap">
      <div className="container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-4 pb-2">
            <li className="breadcrumb-item">
              <Link to="/">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">
              <Link to={`/campaign/${camp_id}/edit`}>Edit Template</Link>
            </li>
            <li className="breadcrumb-item active">Configure audio</li>
          </ol>
        </nav>
        {/* <Link
          className="btn btn-success pull-right"
          to={`/campaign/${camp_id}/edit`}
        >
          Edit Template
        </Link> */}

        <div className="row">
          {isValidURL && (
            <>
              <div className="col-sm-12"></div>

              <h3 className="mb-4 text-center">Configure audio</h3>

              <div className="bx_a">
                {audios.length > 0 && <Multiplayer audios={audios} />}
              </div>
            </>
          )}
          {!isValidURL && <p>Invalid URL!!</p>}
        </div>
      </div>
    </section>
  );
};

export default AudioList;
